// Exports
export default {
	"touchNativeAppBanner": "touchNativeAppBanner_dB5OB",
	"fourButtonsLayout": "fourButtonsLayout_4aiVt",
	"left": "left_jUyZu",
	"right": "right_lIl5H",
	"title": "title_YSJwq",
	"description": "description_bvTcn",
	"spot": "spot_I5sNp",
	"phone": "phone_NRdeg"
};
